<template>
<div style="margin-bottom: 100px;">

  <div style="display: flex; flex-direction: row; justify-content: space-between;">
    <div class="d-flex align-center" style="gap: 80px;">

      <pop-ta-score-label
        v-if="!suppressPopTaScoreHeader && isWhiteGloveUser && site?.ta_score"
        class="mb-6"
        :ta_score="site?.ta_score"
      />

    </div>
  </div>
  
  <div
    class="flex white-selected-box h78 justify-space-between mt-4 gap20"
    style="min-width: 600px;"
    v-if="selectedKeywords?.length"
  >
    <div class="flex">
      <div class="box-primary-bg d-flex align-center">
        <div class="count-value px-5">
          {{ selectedKeywords?.length || 0 }}
        </div>
      </div>
      <div class="px-3 d-flex align-center">
        <div class="selected-text">Item{{ selectedKeywords?.length === 1 ? '':'s'}} selected</div>
      </div>
    </div>  
    <div class="d-flex flex-wrap align-center">
      <div class="flex gap15 align-center fill-height">
        <span
          class="flex flex-column align-center cursor-pointer"
          style="width: 8rem;"
          @click="updateKeywordLabel(selectedKeywords.map(k => k.keyword), 'T'); selectedKeywords = []"
        >
          <div style="line-height: 28px;color: var(--v-profileAnchorColor-base);font-weight: bold;font-size: 24px;">TL</div>
          <div class="action-title">Mark as Top-level</div>
        </span>
        <span
          class="flex flex-column align-center cursor-pointer"
          style="width: 9rem;"
          @click="updateKeywordLabel(selectedKeywords.map(k => k.keyword), 'ST'); selectedKeywords = []"
        >
          <div style="line-height: 28px;color: var(--v-profileAnchorColor-base);font-weight: bold;font-size: 24px;">STL</div>
          <div class="action-title">Mark as Secondary TL</div>
        </span>
        <span
          class="flex flex-column align-center cursor-pointer"
          style="width: 8rem;"
          @click="updateKeywordLabel(selectedKeywords.map(k => k.keyword), 'S'); selectedKeywords = []"
        >
          <div style="line-height: 28px;color: var(--v-profileAnchorColor-base);font-weight: bold;font-size: 24px;">S</div>
          <div class="action-title">Mark as Supporting</div>
        </span>
        <span
          v-if="!isContentOnlyView"
          class="flex flex-column align-center cursor-pointer"
          @click="openBulkModal()"
        >
          <i class="material-icons-outlined orange-color">post_add</i>
          <div class="action-title">{{ isWhiteGloveUser ? 'Add to content plan' : 'Add to silo' }}</div>
        </span>
        <span
          v-if="!isWhiteGloveUser || (isWhiteGloveUser && isMissionControlSession)"
          class="flex flex-column align-center cursor-pointer w78"
          @click="bulkTrackKeyword()"
        >
          <i class="material-icons orange-color">add_circle_outline</i>
          <div class="action-title">Track</div>
        </span>
        <span class="flex flex-column align-center cursor-pointer w78"
          @click="updateKeywordsVisibility(selectedKeywords.map(k => k.keyword), false)"
        >
          <i class="material-icons-outlined orange-color">visibility_off</i>
          <div class="action-title">Hide</div>
        </span>
        <div
          class="cross-container flex justify-center align-center fill-height px-5"
        >
          <i @click="resetSelectedKeywords" class="material-icons cursor-pointer">close</i>
        </div>
      </div>
    </div>
  </div>

  <keyword-research-result-controls
    :reportType="reportType"
    :report="report"
    :siloResearchType="siloResearchType"
    :parentReport="parentReport"
    :siteId="siteId"
    :campaignId="campaignId"
    :topicsWithMetrics="topicsWithMetrics"
    :search.sync="search"
    :showAdvancedMetrics.sync="showAdvancedMetrics"
    :researchHistory="researchHistory"
    :changeResearchAction="changeResearchAction"
    :renameResearchAction="renameResearchAction"
    :updateFavoriteStatus="updateFavoriteStatus"
    :deleteResearchAction="deleteResearchAction"
    :rowsWithAdvancedMetrics="rowsWithAdvancedMetrics"
    :isStartingAIAsyncTask="isStartingAIAsyncTask"
    :isAwaitingAIAsyncTaskStatus="isAwaitingAIAsyncTaskStatus"
    :currentAIAsyncTask="currentAIAsyncTask"
    :isWhiteGloveUser="isWhiteGloveUser"
    :isMissionControlSession="isMissionControlSession"
    :isContentOnlyView="isContentOnlyView"
    :aiTopicFieldValue.sync="aiTopicFieldValue"
    :analyzeWithAI="analyzeWithAI"
    :showFilterPopup.sync="showFilterPopup"
    :allAppliedFilters="allAppliedFilters"
    :filterKeywordScoreMinMax="filterKeywordScoreMinMax"
    :filterKeywordScoreRange.sync="filterKeywordScoreRange"
    :filterKGRMinMax="filterKGRMinMax"
    :filterKGRRange.sync="filterKGRRange"
    :filterDifficultyScoreMinMax="filterDifficultyScoreMinMax"
    :filterDifficultyScoreRange.sync="filterDifficultyScoreRange"
    :applyFitlersAction="applyFitlersAction"
    :updateFilterRangeReset="updateFilterRangeReset"
    :isColumnVisible="isColumnVisible"
    :setColumnVisibility="setColumnVisibility"
    :resetColumnVisibility="resetColumnVisibility"
    :hideableColumns="hideableColumns"
    :hiddenColumnsKeys="hiddenColumnsKeys"
    :showGraphChart.sync="showGraphChart"
    :showHiddenRowsModal.sync="showHiddenRowsModal"
    :hiddenRows.sync="hiddenRows"
    :tableId="tableId"
    :title="title"
    :visibleTableColumns="visibleTableColumns"
    :filteredRows="filteredRows"
    :select-all-checked="filteredRows.length > 0 && selectedKeywords.length === filteredRows.length"
    :select-all-indeterminate="selectedKeywords.length > 0 && selectedKeywords.length < filteredRows.length"
    :selectedKeywords.sync="selectedKeywords"
    :selected-count="selectedKeywords.length"
    :select-all-disabled="!filteredRows.length"
    :hasLabeledKeywords="hasLabeledKeywords"
    :isValidKeywordSelectionForContentOrder="isValidKeywordSelectionForContentOrder"
    :showContentOrderFormForKeywords.sync="showContentOrderFormForKeywords"
    @toggle-select-all="toggleSelectAll"
  />

  <horizontal-two-scroll-bar class="mb-10">
    <div class="pt-2 pb-2">
      <v-card
        v-if="!showGraphChart"
        class="white-common-box"
        style="width: 100%; overflow: initial !important;"
      >
        <div style="overflow-x: auto;">
          
            <table class="keyword-result-table" v-if="report && !showGraphChart" :id="tableId">
              <thead>
                <tr>
                  <th rowspan="2">
                    <div></div>
                  </th>
                  <th rowspan="2"
                    v-for="(col, idx) in COMMON_COLUMNS.filter(column => isColumnVisible(column.key))" :key="idx+'common'" @click="changeSortField(col.value)"
                    :style="{
                      'text-align': col.align || 'start',
                    }"
                  >
                    <template v-if="col.tooltipText">
                      <v-tooltip top color="transparent">
                        <template v-slot:activator="{ on, attrs }">
                          <span
                            v-bind="attrs" v-on="on">
                            {{ col.label }}
                          </span>
                        </template>
                        <div class="white-bg-tooltip small-tooltip p-3">
                          <span class="tooltip-heading">{{ col.tooltipHeading ? col.tooltipHeading : col.label }}</span><br /><br />
                          <span class="tooltip-discription" v-html="keywordTypeColumnTooltip(col)"></span>
                        </div>
                      </v-tooltip>
                    </template>
                    <template v-else>
                      {{ col.label }}
                    </template>
                    <i v-if="sortField == col.value" :class="{ 'fa': true, 'fa-sort-amount-asc': sortBy == 'asc', 'fa-sort-amount-desc': sortBy == 'desc' }"></i>
                  </th>
                  <th
                    v-if="isColumnVisible('_trafficEstimatePerMonth')"
                    colspan="6"
                    scope="colgroup"
                  >
                    <v-tooltip top color="transparent">
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          v-bind="attrs" v-on="on">
                          Traffic Estimates per Month by Rank Position
                        </span>
                      </template>
                      <div class="white-bg-tooltip small-tooltip">
                        These columns provide an estimate on the amount of traffic that you would receive based on ranking in Google for a particular keyword. The 1st and 2nd pages of Google search results are the most important pages as nearly all traffic comes from those two pages. The first page of Google search results constitutes rankings #1-10. The 2nd page of Google search results start at ranking position #11.
                      </div>
                    </v-tooltip>
                  </th>
                  <template v-if="isColumnVisible('_searchTrend')">
                    <th :colspan="forceHideSearchTrendChartColumn?12:13" scope="colgroup" style="text-align: center;">
                      <v-tooltip top color="transparent">
                        <template v-slot:activator="{ on, attrs }">
                          <span
                            v-bind="attrs" v-on="on">
                            Search Volume Trends
                          </span>
                        </template>
                        <div class="white-bg-tooltip small-tooltip">
                          Shows the monthly search volume trends for a keyword, helping identify seasonal interest or fluctuating demand over time.
                        </div>
                      </v-tooltip>              
                    </th>
                  </template>
                  <th rowspan="2">Actions</th>
                </tr>    
                <tr>
                  <template v-if="isColumnVisible('_trafficEstimatePerMonth')">
                    <th v-for="(col, idx) in MONTHLY_SEARCH_COLUMNS" :key="idx+'monthly'" @click="changeSortField(col.value)">
                      {{ col.label }}
                      <i v-if="sortField == col.value" :class="{ 'fa': true, 'fa-sort-amount-asc': sortBy == 'asc', 'fa-sort-amount-desc': sortBy == 'desc' }"></i>
                    </th>
                  </template>
                  <template v-if="isColumnVisible('_searchTrend')">
                    <th v-for="(col, idx) in SEARCH_TREND_COLUMNS.filter(c => (c?.key === 'Search_Volumn_Chart' && !forceHideSearchTrendChartColumn) || c?.key !== 'Search_Volumn_Chart' )" :key="idx+'search_trend'">{{ col.label }}</th>
                  </template>
                </tr>
              </thead>
              <tbody>
                <template v-for="(section, si) in tableBodySections">
                <tr
                  v-if="section.header"
                  :key="'kwg-h-' + si + '-' + section.header.tier"
                  class="keyword-type-group-header"
                >
                  <td :colspan="keywordResultBodyColspan" class="keyword-type-group-header__cell">
                    <strong>{{ section.header.label }} ({{ section.header.count }})</strong>
                  </td>
                </tr>
                <tr
                  v-for="(r, idx) in section.rows"
                  :key="'kwg-r-' + (r.id != null ? r.id : r.keyword) + '-' + section.startRowIndex + '-' + idx"
                  @mouseover="isCurrentIdx = section.startRowIndex + idx"
                  @mouseleave="isCurrentIdx = null"
                  :class="{'highlight-row': $route.query.highlight && Number($route.query.highlight) === r.id, 'highlight-row-active': isHighlightRowActive }"
                >
                  <td>
                    <v-checkbox
                      class="wg-result-select-all-checkbox ma-0 pt-0"
                      color="success"
                      off-icon="none"
                      on-icon="check"
                      :ripple="false"
                      hide-details
                      :input-value="selectedKeywords.includes(r)"
                      @change="toggleSelectedKeyword(r)"
                    />
                  </td>
                  <td v-for="(col, j) in visibleTableColumns.filter(c => (c?.key === 'Search_Volumn_Chart' && !forceHideSearchTrendChartColumn) || c?.key !== 'Search_Volumn_Chart' )" :key="section.startRowIndex + idx + '_' + j + 'col'" :style="styleForCell( col.value, r )">
                    <div 
                      class="d-flex align-center gap5"
                      :class="{
                        'justify-start': col.align == 'start', 'justify-center': col.align == 'center', 'justify-end': col.align == 'end',
                        'keyword-col': col.value == 'keyword'
                      }"
                      >
                      <div v-if="col.value == 'keyword'">
                        <template v-if="!isWhiteGloveUser || (isWhiteGloveUser && isMissionControlSession)">
                          <b-tooltip
                            v-if="trackedKeywords.includes(r.keyword)"
                            label="Tracked Keyword"
                            type="is-dark"
                          >
                            <span @click="() => {
                              toggleTrackUntrackKeyword(false, r)
                            }">
                              <i class="material-icons" style="color: var(--v-green7Color-base);">check_circle</i>
                            </span>
                          </b-tooltip>
                          <b-tooltip
                            v-else
                            label="Track keyword"
                            type="is-dark"
                          >
                            <v-menu
                              offset-y
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <span
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <i class="material-icons add-icon grayColor--text">add_circle</i>
                                </span>
                              </template>
                              <v-list>
                                <v-list-item style="border-bottom: 1px solid var(--v-grayColor-base);">
                                  <b>Track keyword</b>
                                </v-list-item>
                                <v-list-item
                                  style="border-bottom: 1px solid var(--v-grayColor-base); gap: 10px;"
                                  @click="toggleTrackUntrackKeyword(true, r)"
                                >
                                  Add to All Keywords <span class="tag">DEFAULT</span>
                                </v-list-item>
                                <v-list-item
                                  v-for="listName in trackKeywordLists"
                                  :key="listName"
                                  style="border-bottom: 1px solid var(--v-grayColor-base); gap: 5px;"
                                  @click="toggleTrackUntrackKeyword(true, r, listName=listName)"
                                >
                                  Add to <b>{{listName}}</b> list
                                </v-list-item>
                                <v-list-item
                                  style="padding-top: 6px;"
                                >
                                  <v-btn
                                    outlined block color="grayColor" class="text-none"
                                    @click="showAddToNewTrackListModalFor = r; newListFieldValue = '';"
                                  >
                                    <i class="material-icons-outlined" style="margin-left: -8px; color: var(--v-mainColor3-base);">add</i>
                                    <span style="color: var(--v-mainColor3-base);">Create new list</span>
                                  </v-btn>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </b-tooltip>
                        </template>
                      </div>
                      <div v-if="col.value == 'currentRankingUrl' && isURL(r[col.value] || '')">
                        <a :href="r[col.value]" target='_blank' class='open-url-link'>{{ r[col.value] }}</a>
                      </div>
                      <div v-else-if="col.value == 'keywordType'" class="d-flex gap10 align-center" style="width: 100%;">
                        <v-menu
                          :key="'kw-type-menu-' + (r.id != null ? r.id : r.keyword) + '-' + (r.isTopLevelKeyword ? '1' : '0') + '-' + (r.isSecondaryKeyword ? '1' : '0') + '-' + (r.isSupportingKeyword ? '1' : '0')"
                          offset-y
                          :disabled="keywordsOngoingLabelUpdate.indexOf(r.keyword) >= 0"
                        >
                          <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
                            <v-tooltip
                              v-if="r.isTopLevelKeyword || r.isSupportingKeyword"
                              top
                              color="transparent"
                            >
                              <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                                <span
                                  v-bind="Object.assign({}, tooltipAttrs, menuAttrs)"
                                  v-on="Object.assign({}, tooltipOn, menuOn)"
                                  class="box-container cursor-pointer"
                                >
                                  <span
                                    v-if="r.isTopLevelKeyword && r.isSecondaryKeyword"
                                    class="wg-keyword-insight-single__tag wg-keyword-insight-single__tag--stl"
                                  >
                                    STL
                                    <i
                                      v-if="keywordsOngoingLabelUpdate.indexOf(r.keyword) < 0"
                                      class="fa fa-angle-down wg-keyword-insight-single__tag__chevron"
                                      aria-hidden="true"
                                    />
                                    <i
                                      v-else
                                      class="fa fa-spinner fa-spin wg-keyword-insight-single__tag__chevron"
                                      aria-hidden="true"
                                    />
                                  </span>
                                  <span
                                    v-else-if="r.isTopLevelKeyword"
                                    class="wg-keyword-insight-single__tag wg-keyword-insight-single__tag--tl"
                                  >
                                    TL
                                    <i
                                      v-if="keywordsOngoingLabelUpdate.indexOf(r.keyword) < 0"
                                      class="fa fa-angle-down wg-keyword-insight-single__tag__chevron"
                                      aria-hidden="true"
                                    />
                                    <i
                                      v-else
                                      class="fa fa-spinner fa-spin wg-keyword-insight-single__tag__chevron"
                                      aria-hidden="true"
                                    />
                                  </span>
                                  <span
                                    v-else
                                    class="wg-keyword-insight-single__tag wg-keyword-insight-single__tag--s"
                                  >
                                    S
                                    <i
                                      v-if="keywordsOngoingLabelUpdate.indexOf(r.keyword) < 0"
                                      class="fa fa-angle-down wg-keyword-insight-single__tag__chevron"
                                      aria-hidden="true"
                                    />
                                    <i
                                      v-else
                                      class="fa fa-spinner fa-spin wg-keyword-insight-single__tag__chevron"
                                      aria-hidden="true"
                                    />
                                  </span>
                                </span>
                              </template>
                              <div class="white-bg-tooltip small-tooltip p-3">
                                <template v-if="r.isTopLevelKeyword && r.isSecondaryKeyword">
                                  <span class="tooltip-heading">Secondary top-level keyword</span><br /><br />
                                  <span class="tooltip-discription">
                                    A major topic that supports your primary<br />
                                    top-level keyword. Build strong pages for it<br />
                                    and link them toward your main target page.
                                  </span>
                                </template>
                                <template v-else-if="r.isTopLevelKeyword">
                                  <span class="tooltip-heading">Top-level keyword</span><br /><br />
                                  <span class="tooltip-discription">
                                    This is the main keyword your target page<br />
                                    can rank for. The more difficult this keyword<br />
                                    is, the more supporting posts you’ll need
                                  </span>
                                </template>
                                <template v-else>
                                  <span class="tooltip-heading">Supporting keyword</span><br /><br/>
                                  <span class="tooltip-discription">
                                    This is a keyword that you can use to<br />
                                    create supporting pages and point<br />
                                    their links to your main target page.
                                  </span>
                                </template>
                              </div>
                            </v-tooltip>
                            <b-button
                              v-else
                              class="keyword-label-dropdown-button"
                              :loading="keywordsOngoingLabelUpdate.indexOf(r.keyword) >= 0"
                              type="is-ghost"
                              size="is-small"
                              :icon-right="keywordsOngoingLabelUpdate.indexOf(r.keyword) >= 0 ? undefined : 'angle-down'"
                              v-bind="menuAttrs"
                              v-on="menuOn"
                            />
                          </template>
                          <v-list>
                            <v-list-item v-if="reportType !== 'SupportKeywordResearch' && (!r.isTopLevelKeyword || (r.isTopLevelKeyword && r.isSecondaryKeyword))" @click="updateKeywordLabel([r.keyword], 'T')">Mark as a Top-level Keyword</v-list-item>
                            <v-list-item v-if="reportType !== 'SupportKeywordResearch' && !(r.isTopLevelKeyword && r.isSecondaryKeyword)" @click="updateKeywordLabel([r.keyword], 'ST')">Mark as a Secondary Top-level Keyword</v-list-item>
                            <v-list-item v-if="!r.isSupportingKeyword" @click="updateKeywordLabel([r.keyword], 'S')">Mark as a Supporting Keyword</v-list-item>
                            <v-list-item v-if="r.isTopLevelKeyword || r.isSupportingKeyword" @click="updateKeywordLabel([r.keyword], null)">Unmark</v-list-item>
                          </v-list>
                        </v-menu>

                        <!--<v-tooltip v-if="r.isSecondaryKeyword" top color="transparent">
                          <template v-slot:activator="{ on, attrs }">
                            <i class="material-icons-outlined" v-bind="attrs" v-on="on" style="color: #FF5700;">support</i>
                          </template>
                          <div class="white-bg-tooltip small-tooltip p-3 tooltip-arrow">
                            <span class="tooltip-discription">Secondary top-level keyword</span>
                          </div>
                        </v-tooltip>-->
                        
                      </div>
                      <template v-else-if="col.value == 'pageRunScore'">
                        <template v-if="r.pageRunId && !r.pageNotBuilt">
                          <span
                            class="flex align-sm-center justify-md-center cursor-pointer"
                            @click="gotoPage(`/sites/${siteId}/pages/${r.pageId}/pageruns/${r.pageRunId}`)"
                          >
                            <radial-progress-bar
                              :diameter="35"
                              :completed-steps="r.pageRunScore"
                              :total-steps="100"
                              :innerStrokeWidth="6"
                              :strokeWidth="4"
                              :startColor="pageScoreTintColor(r.pageRunScore)"
                              :stopColor="pageScoreTintColor(r.pageRunScore)"
                              :innerStrokeColor="'#D9D9D9'"
                              strokeLinecap="round"
                            />
                            <span class="ml-2">{{ r.pageRunScore }}</span>
                          </span>
                        </template>
                        <span
                          v-else-if="r.pageRunId"
                          class="cursor-pointer"
                          @click="gotoPage(`/sites/${siteId}/pages/${r.pageId}/pageruns/${r.pageRunId}`)"
                        >
                          N/A
                        </span>
                      </template>

                      <template v-else-if="col.value == 'pageRunUrl'">
                        <template v-if="r.pageRunId && !r.pageNotBuilt">
                          <a :href="r[col.value]" target='_blank' class='open-url-link'>{{ r[col.value] }}</a>
                        </template>
                      </template>

                      <template v-else-if="col.value == 'source'">
                        <template v-if="r[col.value]">
                          <span
                            class="tag"
                            :style="{'background-color': '#EBECEB', 'color': '#595959'}"
                            v-bind="attrs" v-on="on"
                          >
                            {{ r[col.value] }}
                          </span>
                        </template>
                      </template>

                      <template v-else-if="col.value == 'keyword_intent'">
                        <template v-if="r[col.value]">
                          <v-tooltip top color="black">
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                class="tag"
                                style="text-transform: uppercase; color: var(--v-blackColor-base); font-weight: 700;"
                                v-bind="attrs" v-on="on"
                              >
                                <template v-if="r[col.value] === 'informational'">Inf</template>
                                <template v-else-if="r[col.value] === 'navigational'">Nav</template>
                                <template v-else-if="r[col.value] === 'commercial'">Com</template>
                                <template v-else-if="r[col.value] === 'transactional'">Tran</template>
                                <template v-else>{{r[col.value]}}</template>
                              </span>
                            </template>
                            <div style="max-width: 300px;">
                              <template v-if="r[col.value] === 'informational'">
                                <b>Informational</b><br/>
                                The person just wants to learn or understand something. They're not looking to buy or do anything yet.<br/>
                                <b>Example:</b> <i>“How to boil an egg”</i><br/>
                                <i>They’re curious or asking a question.</i>
                              </template>
                              <template v-else-if="r[col.value] === 'navigational'">
                                <b>Navigational</b><br/>
                                The person wants to go to a specific website or page they already have in mind.<br/>
                                <b>Example:</b> <i>“YouTube” or “Gmail login”</i><br/>
                                <i>They know where they want to go.</i>
                              </template>
                              <template v-else-if="r[col.value] === 'commercial'">
                                <b>Commercial</b><br/>
                                The person is thinking about buying but wants to compare options or find the best deal first.<br/>
                                <b>Example:</b> <i>“Best phone for gaming 2024”</i><br/>
                                <i>They’re doing research before deciding.</i>
                              </template>
                              <template v-else-if="r[col.value] === 'transactional'">
                                <b>Transactional</b><br/>
                                The person is ready to buy something, sign up, or take action.<br/>
                                <b>Example:</b> <i>“Buy iPhone 15”</i><br/>
                                <i>They’re ready to do something now.</i>
                              </template>
                            </div>
                          </v-tooltip>
                        </template>
                      </template>

                      <span v-else-if="col.value == 'keywordScore'">
                        <span
                          v-if="![undefined, null].includes(r.keywordScore)"
                          class="tag"
                          :style="{...keywordScoreToColorStyles(r.keywordScore), width: '35px'}"
                        >
                          {{ Math.round(r.keywordScore) }}
                        </span>
                        <template v-else>
                          <v-tooltip top color="black">
                            <template v-slot:activator="{ on, attrs }">
                              <span class="font-weight-bold" v-bind="attrs" v-on="on">-</span>
                            </template>
                            <div style="text-align: center;">Select this keyword to get<br/>all available advanced data<br/>(Keyword score, KGR score, SCI,<br/>All In Title)</div>
                          </v-tooltip>
                        </template>
                      </span>
                      <template v-else-if="col.value == 'KGRScore'">
                        <template v-if="![undefined, null].includes(r.keywordScore)">
                          <div>{{ r.KGRScore }}</div>
                          <span class="bullet kgr-score-bullet"
                            :class="{ 'best': r.KGRScore <=2.5, 'good': r.KGRScore > 2.5 && r.KGRScore <= 5, 'normal': r.KGRScore > 5 }">
                          </span>
                        </template>
                        <template v-else>
                          <v-tooltip top color="black">
                            <template v-slot:activator="{ on, attrs }">
                              <span class="font-weight-bold" v-bind="attrs" v-on="on">-</span>
                            </template>
                            <div style="text-align: center;">Select this keyword to get<br/>all available advanced data<br/>(Keyword score, KGR score, SCI,<br/>All In Title)</div>
                          </v-tooltip>
                        </template>
                      </template>
                      <span v-else-if="col.value == 'Search_Volumn_Chart'">
                        <render-if-in-view>
                          <apex-chart type="area" height="35" width="100" :options="searchTrendChartOptions" :series="getRowSearchTrendSeries(r)"></apex-chart>
                        </render-if-in-view>
                      </span>
                      <template v-else-if="col.isAdvancedMetric">
                        <div v-if="![undefined, null].includes(r[col.value])" v-html="renderCellValue(col.value, r[col.value])"></div>
                        <template v-else>
                          <span class="font-weight-bold">-</span>
                        </template>
                      </template>
                      <template v-else-if="col.value == 'keyword'">
                        <div
                          v-html="renderCellValue(col.value, r[col.value])"
                          :style="r.isTopLevelKeyword ? 'font-weight: 700;' : ''"
                        ></div>
                  
                      </template>
                      <template v-else>
                        <div v-html="renderCellValue(col.value, r[col.value])"></div>
                      </template>

                      <span  v-if="col.value == 'keyword'" :style="isCurrentIdx !== section.startRowIndex + idx?'visibility:hidden;':''">
                        <b-tooltip
                          label="Hide"
                          type="is-dark"
                        >
                          <span @click="() => {
                              updateKeywordsVisibility([r['keyword']], false)
                          }">
                            <i class="material-icons">close</i>
                          </span>
                        </b-tooltip>
                      </span>
                    </div>
                  </td>
                  <td>
                      <div class="flex kr-result-row-actions" style="width: max-content;">

                        <b-tooltip
                          v-if="isMissionControlSession"
                          label="Generate POP report"
                          type="is-dark"
                        >
                          <v-btn
                            text
                            small
                            color="profileAnchorColor"
                            :ripple="false"
                            class="text-none"
                            @click="gotoNewPopReport(r)"
                          >
                            <span class="font-weight-bold">POP report</span>
                          </v-btn>
                        </b-tooltip>  

                        <v-btn
                          v-if="!r.isSupportingKeyword && !r.isTopLevelKeyword"
                          text
                          small
                          color="profileAnchorColor"
                          class="kr-result-row-actions__hover-btn"
                          disabled
                        >
                          <i class="material-icons-outlined">post_add</i>
                        </v-btn>
                        <div v-else-if="allSiloKeywords.includes(r.keyword)">
                          <v-tooltip top color="transparent">
                            <template
                              v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }"
                            >
                              <v-menu :close-on-content-click="false" :nudge-width="200">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="Object.assign({}, tooltipAttrs, attrs)"
                                    v-on="Object.assign({}, tooltipOn, on)"
                                    text
                                    small
                                    color="profileAnchorColor"
                                    class="kr-result-row-actions__hover-btn"
                                    disabled
                                  >
                                    <i
                                      class="success material-icons"
                                      style="color: #25A97A !important; background-color: transparent !important; font-size: 1.4rem;"
                                    >check_circle</i>
                                  </v-btn>
                                </template>

                                <v-card>
                                  <div
                                    class="silo-popup"
                                    style="padding: 15px; width: 21.75rem"
                                  >
                                    <div>
                                      <span
                                        >You have already added this keyword to the
                                        {{ isWhiteGloveUser ? 'content plan' : 'silo' }}.</span>
                                      <v-btn
                                        rounded
                                        color="profileAnchorColor"
                                        class="text-none whiteColor--text mt-5"
                                        @click="
                                          applyKeywordSilo(
                                            fetchSiloFromKeyword(r.keyword)?.id,
                                          )
                                        "
                                      >
                                        <span>Open {{ isWhiteGloveUser ? 'content plan' : 'Silo' }}</span>
                                      </v-btn>
                                    </div>
                                  </div>
                                </v-card>
                              </v-menu>
                            </template>
                            <div class="white-bg-tooltip small-tooltip p-3">
                              <span class="tooltip-discription">
                                This {{r.isTopLevelKeyword?'Top-level':(r.isSupportingKeyword?'Supporting':'')}} Keyword was added to {{ isWhiteGloveUser ? 'Content plan' : 'Silo' }} <strong id="silo-name">{{fetchSiloFromKeyword(r.keyword).name}}</strong>
                              </span>
                            </div>
                          </v-tooltip>
                        </div>
                        <template v-else>
                          <v-tooltip top color="transparent">
                            <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                              <v-menu
                                
                                :close-on-content-click="false"
                                :nudge-width="200"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="Object.assign({}, tooltipAttrs, attrs)"
                                    v-on="Object.assign({}, tooltipOn, on)"
                                    text
                                    small
                                    color="profileAnchorColor"
                                    class="kr-result-row-actions__hover-btn"
                                  >
                                    <i
                                      class="material-icons-outlined"
                                      >post_add</i
                                    >
                                  </v-btn>
                                </template>
                                <v-card>
                                  <div class="silo-new-popup" style="padding: 15px">
                                    <div class="filter-item-label"></div>
                                    <div>
                                      <v-text-field
                                        outlined
                                        dense
                                        hide-details
                                        :label="isWhiteGloveUser ? 'Search content plans' : 'Search silos'"
                                        prepend-inner-icon="search"
                                        class="search-field"
                                        v-model="siloSearch"
                                      >
                                      </v-text-field>
                                      <div
                                        class="flex flex-column gap5 pt-2"
                                        style="max-height: 200px; overflow-y: auto;"
                                      >
                                        <div
                                          v-for="(silo, idx) in filteredSilos"
                                          @click="addKeywordToSilo(r, silo)"
                                          :key="idx"
                                          class="flex gap5 align-center cursor-pointer"
                                        >
                                          <i
                                            v-if="silo.silo_keywords.some(keyword => keyword.keywordData.isTopLevelKeyword)"
                                            class="material-icons-outlined green-check"
                                            style="color: var(--v-green21Color-base);"
                                          >
                                            check
                                          </i>
                                          <i v-else class="material-icons-outlined green-check">
                                            check
                                          </i>
                                          <span>{{ silo.name }}</span>
                                        </div>
                                      </div>
                                      <div
                                        class="flex gap2 align-center mt-2 cursor-pointer"
                                        style="margin-left: 8px"
                                        @click="() => openSiloModal(r)"
                                      >
                                        <img
                                          src="/static/add_orange.svg"
                                          style="
                                            background-color: transparent;
                                            width: auto;
                                            height: auto;
                                            margin-left: -4px;
                                          "
                                        />
                                        <span
                                          class="primary-text"
                                          style="
                                            margin-left: 6px;
                                            color: var(--v-profileAnchorColor-base);
                                            font-size: 0.85rem;
                                            font-weight: 700;
                                          "
                                          >{{ isWhiteGloveUser ? 'Create new content plan' : 'Create new silo' }}</span
                                        >
                                      </div>
                                      <div></div>
                                    </div>
                                  </div>
                                </v-card>
                              </v-menu>
                            </template>
                            <div class="white-bg-tooltip small-tooltip p-3">
                              <span class="tooltip-heading">{{ isWhiteGloveUser ? 'Add this keyword to a content plan.' : 'Add this keyword to a content Silo.' }}</span><br />
                              <span class="tooltip-discription">
                                {{ isWhiteGloveUser ? 'A content plan can contain up to 4 Top-level Keywords and up to 15 Supporting Keywords.' : 'A Silo can contain up to 4 Top-level Keywords and up to 15 Supporting Keywords.' }}
                              </span>
                            </div>
                          </v-tooltip>
                        </template>

                        <template v-if="isWhiteGloveUser">
                          <v-tooltip v-if="allQuickContentOrderKeywords.includes(r.keyword)" top color="transparent">
                            <template
                              v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }"
                            >
                              <v-menu :close-on-content-click="false" :nudge-width="200">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="Object.assign({}, tooltipAttrs, attrs)"
                                    v-on="Object.assign({}, tooltipOn, on)"
                                    text
                                    small
                                    color="profileAnchorColor"
                                    class="kr-result-row-actions__hover-btn"
                                    disabled
                                  >
                                    <i
                                      class="success material-icons"
                                      style="color: #25A97A !important; background-color: transparent !important; font-size: 1.4rem;"
                                    >check_circle</i>
                                  </v-btn>
                                </template>

                                <v-card>
                                  <div
                                    class="silo-popup"
                                    style="padding: 15px; width: 21.75rem"
                                  >
                                    <div>
                                      <span
                                        >You have already added this keyword to an order.</span
                                      >
                                      <v-btn
                                        rounded
                                        color="profileAnchorColor"
                                        class="text-none whiteColor--text mt-5"
                                        @click="
                                          applyKeywordContentOrderSilo(
                                            fetchContentOrderSiloFromKeyword(r.keyword)?.id,
                                          )
                                        "
                                      >
                                        <span>Open Order</span>
                                      </v-btn>
                                    </div>
                                  </div>
                                </v-card>
                              </v-menu>
                            </template>
                            <div class="white-bg-tooltip small-tooltip p-3">
                              <span class="tooltip-discription">
                                This {{r.isTopLevelKeyword?'Top-level':(r.isSupportingKeyword?'Supporting':'')}} Keyword was added to Order <strong id="silo-name">{{fetchContentOrderSiloFromKeyword(r.keyword).name}}</strong>
                              </span>
                            </div>
                          </v-tooltip>
                      
                          <v-menu
                            v-else
                            open-on-hover
                            offset-y
                            transition="scale-transition"
                            top
                            left
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                text
                                small
                                class="kr-result-row-actions__hover-btn"
                                @click="showContentOrderFormForKeywords = [r]"
                                :disabled="!isValidKeywordSelectionForContentOrder([r])"
                              >
                                <template v-if="isValidKeywordSelectionForContentOrder([r])">
                                  <img
                                    v-if="!$vuetify.theme.dark"
                                    class="quick-content-icon"
                                    src="/static/quick_content_icon_orange.svg"
                                    style="width:20px; height:20px;"
                                  />
                                  <img
                                    v-else
                                    class="quick-content-icon"
                                    src="/static/quick_content_icon_gray.svg"
                                    style="width:20px; height:20px;"
                                  />
                                </template>
                                <template v-else>
                                  <img class="quick-content-icon" src="/static/quick_content_icon_gray.svg" style="width:20px; height:20px;" />
                                </template>
                              </v-btn>
                            </template>

                            <v-card >
                              <div v-if="!isValidKeywordSelectionForContentOrder([r])" class="white-bg-tooltip large-tooltip p-4">
                                    <h4 class="tooltip-heading">To order quick content:</h4>
                                    <div class="tooltip-discription">
                                      <div class="step">
                                        <div>STEP 1</div>
                                        <p>Mark keywords as Top-Level or Supporting:</p>
                                        <p>First select and mark keywords that you want content written for as either Top-Level or Supporting.</p>
                                        <ul>
                                          <li><span>Top-Level (or Target pages)</span> are key sales or conversion pages on your site – like a product or service page you want to boost.</li>
                                          <li><span>Supporting pages</span> cover related subtopics and internally link back to strengthen your Top-Level page.</li>
                                        </ul>
                                      </div>
                                      <div class="step">
                                        <div>STEP 2</div>
                                        <p> <span>Select keywords and complete the checkout:</span> <br />For the selected keywords, pick the type of content you'd like us to write. You can also specify things like tone of voice, keywords to avoid and more.</p>
                                      </div>
                                      <div class="learn-more"  @click.prevent="openHowtoUseGuide()">
                                        <a class="link-text">More about Top-Level and Supporting pages</a>
                                      </div>
                                    </div>
                              </div>

                                <div v-else class="white-bg-tooltip small-tooltip p-3">
                                      <span class="tooltip-heading">Order content</span>
                                </div>
                            </v-card>
                          </v-menu>
                        </template>

                      </div>
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
        </div>
      </v-card>
      <silo-result-table-graph
        v-if="report"
        :style="showGraphChart?'':'position:fixed; top: 200%; left: 200%;'"
        :graph-data="graphData"
        :key="graphDataRepr"
      />
    </div>
  </horizontal-two-scroll-bar>
  <silo-pop-up :popUpSilo="popUpSilo" :campaign-id="campaignId" @closeModal="closeSiloModal" @addKeywordToSilo="addKeywordToSilo" />
  <silo-bulk-pop-up 
    :popUpSilo="bulkPopUp" 
    :campaign-id="campaignId"
    :keywords="selectedKeywords" 
    @openSiloModal="openSiloModal" 
    :silos="silos" 
    @closeModal="closeBulkModal" 
    @bulkAddKeywordToSilo="bulkAddKeywordToSilo" 
    @fetchSilos="fetchSilos"
  />

  <div class="modal hidden-rows-modal" :class="{'is-active': showHiddenRowsModal}">
    <div class="modal-background" @click.stop="showHiddenRowsModal = false"></div>
    <div class="modal-content">
      <div class="box modal-container">
        <div class="modal-content-root">
          <p class="title-font is-size-4 blackColor--text">Hidden rows ({{ hiddenRows.length }})</p>
          <div class="blackColor--text message-text">
            <template v-if="hiddenRows.length">
              <div class="mt-6 mb-6">
                <a class="font-weight-bold" href="#" @click.stop.prevent="updateKeywordsVisibility(hiddenRows.map(row => row.keyword), true)">Unhide all</a>
              </div>
              <ul class="mb-2" style="list-style: initial;">
                <li v-for="row in hiddenRows" :key="row.keyword">{{ row.keyword }} (<a href="#" @click.stop.prevent="updateKeywordsVisibility([row.keyword], true)" class="font-weight-bold">unhide</a>)</li>
              </ul>
            </template>
            <template v-else>
              No hidden rows
            </template>
          </div>
          <div class="d-flex justify-end gap10 mt-5">
            <v-btn rounded outlined color="blackColor"
              class="text-none"
              @click.stop="() => {
                showHiddenRowsModal = false;
              }">
              <span>Close</span>
            </v-btn>
            
          </div>
        </div>
      </div>
      <button
        class="custom-modal-close-btn"
        aria-label="close"
        @click="() => (showHiddenRowsModal = false)">
        <i class="material-icons">close</i>
      </button>
    </div>
  </div>
  <keyword-research-modal
    :showModal="showModal"
    :modalTitle="modalTitle"
    :modalType="modalType"
    :reportTitle="reportTitle"
    @cancel="cancelModal"
    @close="closeModal"
    @update-title="updateReportTitle"
  />

  <div v-if="showAddToNewTrackListModalFor" class="modal search-keywords-cost-modal" :class="{'is-active': true}">
    <div class="modal-background" @click.stop="showAddToNewTrackListModalFor = null;"></div>
    <div class="modal-content">
      <div class="box modal-container">
        <div class="modal-content-root">
          <p class="title-font is-size-4 mainColor3--text mb-8">Add "{{showAddToNewTrackListModalFor.keyword}}" to a new tracking list</p>

          <div>
            <div
              class="mb-2"
              style="font-size: 0.9rem; font-weight: 700; color: var(--v-mainColor3-base);"
            >
              Name
            </div>

            <v-text-field
              v-model="newListFieldValue"
              :autofocus="true"
              placeholder="Enter list name"
              hide-details
              outlined
              dense
              color="grayColor"
            />
          </div>

          <div class="d-flex justify-end gap10 mt-8">
            <v-btn
              outlined color="grayColor" class="text-none"
              @click="showAddToNewTrackListModalFor = null;"
            >
              <span style="color: var(--v-mainColor3-base);">Cancel</span>
            </v-btn>
            <v-btn color="profileAnchorColor"
              :disabled="!newListFieldValue || trackKeywordLists.map(name => name.toLowerCase()).includes(newListFieldValue.toLowerCase())"
              class="whiteColor--text text-none"
              @click.stop="toggleTrackUntrackKeyword(true, showAddToNewTrackListModalFor, listName=newListFieldValue)">
              <span style="font-weight: 700;">Save</span>
            </v-btn>
            
          </div>
        </div>
      </div>
      <button
        class="custom-modal-close-btn"
        aria-label="close"
        @click="showAddToNewTrackListModalFor = null;">
        <i class="material-icons">close</i>
      </button>
    </div>
  </div>

  <content-order-form
    v-if="showContentOrderFormForKeywords?.length"
    :isQuickContentOrderView="true"
    :isEditMode="true"
    :initialKeywords="showContentOrderFormForKeywords"
    :sourceReport="report"
    :sourceReportType="reportType"
    :refreshData="fetchSilos"
    :projectTitle="site?.name || ''"
    @close="showContentOrderFormForKeywords = null"
  />

</div>
</template>


<script>
import { pageScoreTintColor, getPureServicePkgName } from '@/utils';
import RadialProgressBar from 'vue-radial-progress';
import KeywordResearchModal from '@/common/KeywordResearchModal.vue';
import {
  whiteGlovePlans,
} from "@/components/plans_constants"

const SEARCH_COLUMN_VALUES = [
  "Search_Volumn_January",
  "Search_Volumn_February",
  "Search_Volumn_March",
  "Search_Volumn_April",
  "Search_Volumn_May",
  "Search_Volumn_June",
  "Search_Volumn_July",
  "Search_Volumn_August",
  "Search_Volumn_September",
  "Search_Volumn_October",
  "Search_Volumn_November",
  "Search_Volumn_December",
]
const COMMON_COLUMNS = [
  { key: "keyword", label: "Keyword", value: "keyword", align: 'start' },
  {
    key: "source", label: "Keyword Source", value: "source", align: 'center',
  },
  { 
    key: "keywordType",
    label: "Type",
    value: "keywordType",
    tooltipHeading: "Keyword Type",
    tooltipText: "Indicates whether a keyword is a <b>primary focus (Top Level)</b> for a content silo or a <b>related term (Supporting Keyword)</b> that helps reinforce the topic.",
    downloadButtonValue: (row) => {
      if (row.isTopLevelKeyword && row.isSecondaryKeyword) {
        return 'Secondary top-Level Keyword'
      }
      if (row.isTopLevelKeyword) {
        return 'Top-Level Keyword'
      }
      if (row.isSecondaryKeyword) {
        return 'isSecondaryKeyword Keyword'
      }
      if (row.isSupportingKeyword) {
        return 'Supporting Keyword'
      }
      return ''
    },
    align: 'end'
  },
  {
    key: "keyword_intent", label: "Intent", value: "keyword_intent", align: 'center',
    tooltipHeading: 'Keyword Intent',
    tooltipText: "This shows what the person is trying to do when they search a keyword — whether they’re just looking for info, trying to visit a site, ready to take action (like buy something), or comparing options before a decision.",
  },
  {
    key: "pageRunScore", label: "POP Score", value: "pageRunScore", align: 'center',
    tooltipText: "The POP Rank Engine™️ evaluates over 300 SEO factors to provide recommendations aimed at improving your on-page SEO. This score reflects the effectiveness of your page optimization based on ongoing SEO experiments.",
    isAdvancedMetric: true,
  },
  {
    key: "pageRunUrl", label: "POP URL", value: "pageRunUrl", align: 'start',
    tooltipText: "This is the page we analyzed in the POP report. If it’s different from what’s ranking, you might want to update your SEO focus or check why a different page is ranking.",
    isAdvancedMetric: true,
  },
  { key: "keywordScore", label: "Keyword score", value: "keywordScore", align: 'end',
    tooltipText: 'The Keyword Score indicates the value of a keyword for your SEO strategy. It combines monthly search volume, competition strength, and keyword difficulty into a single, color-coded score, with darker greens signaling better keyword opportunities.',
    isAdvancedMetric: true,
  },
  {
    key: "KGRScore", label: "KGR score", value: "KGRScore", align: 'end',
    tooltipText: "The Keyword Golden Ratio metric identifies low-competition, high-opportunity keywords by calculating the ratio of Google search results to local monthly search volume. A score below 2.5 suggests a strong chance to rank in the top 50 results.",
    isAdvancedMetric: true,
  },
  {
    key: "realCompMajesticTitleAndAnchorComp", label: "SCI", value: "realCompMajesticTitleAndAnchorComp", align: 'end',
    tooltipHeading: "SEO Competitiveness Index (SCI)",
    tooltipText: "The SEO Competitiveness Index score evaluates how competitive a keyword is based on the frequency of title optimization and the presence of relevant anchor text in backlinks. Higher SCI indicates more competitors actively optimizing for this keyword.",
    isAdvancedMetric: true,
  },
  {
    key: "allintitle", label: "All In Title", value: "allintitle", align: 'end',
    tooltipText: "This metric shows the number of pages that use the exact keyword in their title tag. A higher number suggests more competition targeting the keyword in on-page SEO.",
    isAdvancedMetric: true,
  },
  {
    key: "broadMatchMonthlySearches_LowEstimate", label: "Monthly searches low", value: "broadMatchMonthlySearches_LowEstimate", align: 'end',
    tooltipText: 'This represents the lowest estimated monthly search volume for a keyword, helping you gauge its baseline popularity.',    
  },
  {
    key: "broadMatchMonthlySearches_HighEstimate", label: "Monthly searches high", value: "broadMatchMonthlySearches_HighEstimate", align: 'end',
    tooltipText: 'This represents the highest estimated monthly search volume for a keyword, indicating peak search demand.',
  },
  {
    key: "ai_search_demand", label: "AI Search Demand", value: "ai_search_demand", align: 'end',
    tooltipHeading: 'AI Search Demand (Search Volume in AI tools)',
    tooltipText: 'This shows <b>how many people search for a topic</b>, on average, in a selected country/language.<ul style="list-style-type: initial; margin-bottom: 15px;"><li><b>What it answers:</b> “Is this something people actually look for?”</li><li><b>What you get:</b> an estimated <b>monthly search count</b> for each keyword/topic you track.</li><li><b>Why it matters:</b> it helps you <b>prioritize</b> which topics are worth focusing on (high demand = bigger potential reach).</li><li><b>How to use it:</b> compare topics and pick the ones with the best mix of <b>demand and relevance</b>.</li></ul><b>Example:</b><br/>If you track “best project management tool”, this metric tells you whether it’s searched <b>a lot, a little, or almost never</b>, so you know if it’s worth investing time in.<br/><b>Note:</b> This measures <b>human search interest</b>, not “AI visibility” directly but it helps you choose topics that can drive more traffic when you do get mentioned.',
  },
  {
    key: "difficultyScore", label: "Difficulty score %", value: "difficultyScore", align: 'end',
    tooltipText: 'Indicates how hard it is to rank in the top 10 search results for a keyword, on a scale of 0 to 100. Higher percentages reflect higher competition and ranking difficulty.',
  },
  {
    key: "currentRankGoogle", label: "Current Position (Live Data)", value: "currentRankGoogle",
    tooltipText: "Your current Google ranking position for this keyword, based on live search results. This reflects the ranking of the Current Ranking URL (Live Data). Lower numbers mean higher positions.",
  },
  {
    key: "currentRankingUrl", label: "Current Ranking URL (Live Data)", value: "currentRankingUrl", align: 'start',
    tooltipText: 'The URL of your page currently ranking on Google for the selected keyword.',
  },
  {
    key: "competitionStrength", label: "Competition strength", value: "competitionStrength", align: 'end',
    tooltipText: 'Estimates the competitive strength of a keyword based on difficulty metrics, helping you assess the effort needed to outrank competitors.',
  },
  {
    key: "estimatedTimeToWin_in_Months", label: "Est. Months to Win", value: "estimatedTimeToWin_in_Months", align: 'end',
    tooltipText: "Reflects the anticipated duration, in months, to achieve a top 10 ranking position for a keyword. Ranges are categorized from a fast track of 2-3 months to longer efforts exceeding 12 months.",
    showOnlyAdmin: true,
  },
]
const MONTHLY_SEARCH_COLUMNS = [
  { key: "trafficEstimatePerMonthByRankPos_#1", label: "#1", value: "trafficEstimatePerMonthByRankPos_#1" },
  { key: "trafficEstimatePerMonthByRankPos_#3", label: "#3", value: "trafficEstimatePerMonthByRankPos_#3" },
  { key: "trafficEstimatePerMonthByRankPos_#5", label: "#5", value: "trafficEstimatePerMonthByRankPos_#5" },
  { key: "trafficEstimatePerMonthByRankPos_#7", label: "#7", value: "trafficEstimatePerMonthByRankPos_#7" },
  { key: "trafficEstimatePerMonthByRankPos_#10_#11", label: "#10", value: "trafficEstimatePerMonthByRankPos_#10_#11" },
  { key: "trafficEstimatePerMonthByRankPos_#12_#19", label: "#12+", value: "trafficEstimatePerMonthByRankPos_#12_#19" },
].map(col => ({ ...col, align: 'end' }))
const SEARCH_TREND_COLUMNS = [
  // SEARCH COLUMN OPTIONS
  { key: "Search_Volumn_Chart", label: "Search Trend", value: "Search_Volumn_Chart", align: 'center' },
  { key: "Search_Volumn_January", label: "January", value: "Search_Volumn_January", align: 'center' },
  { key: "Search_Volumn_February", label: "February", value: "Search_Volumn_February", align: 'center' },
  { key: "Search_Volumn_March", label: "March", value: "Search_Volumn_March", align: 'center' },
  { key: "Search_Volumn_April", label: "April", value: "Search_Volumn_April", align: 'center' },
  { key: "Search_Volumn_May", label: "May", value: "Search_Volumn_May", align: 'center' },
  { key: "Search_Volumn_June", label: "June", value: "Search_Volumn_June", align: 'center' },
  { key: "Search_Volumn_July", label: "July", value: "Search_Volumn_July", align: 'center' },
  { key: "Search_Volumn_August", label: "August", value: "Search_Volumn_August", align: 'center' },
  { key: "Search_Volumn_September", label: "September", value: "Search_Volumn_September", align: 'center' },
  { key: "Search_Volumn_October", label: "October", value: "Search_Volumn_October", align: 'center' },
  { key: "Search_Volumn_November", label: "November", value: "Search_Volumn_November", align: 'center' },
  { key: "Search_Volumn_December", label: "December", value: "Search_Volumn_December", align: 'center' },
]
const HIDDEN_COLUMNS_KEYS_DEFAULT = [
  'source',
  '_searchTrend',
  'competitionStrength',
  'estimatedTimeToWin_in_Months',
  '_trafficEstimatePerMonth',
]

import KeywordResearchResultControls from './KeywordResearchResultControls.vue';
import { toLocalDateTimeString } from '@/utils';
import isURL from 'validator/lib/isURL';
import HorizontalTwoScrollBar from '@/common/HorizontalTwoScrollBar.vue';
import SiloPopUp from "@/components/SiloPopUp.vue";
import SiloBulkPopUp from "@/components/SiloBulkPopUp.vue";
import PopTaScoreLabel from '@/components/Campaigns/PopTaScoreLabel.vue';
import ContentOrderForm from '@/components/Campaigns/content-orders/ContentOrderForm/Index.vue'
import SiloResultTableGraph from '@/components/Campaigns/silo/SiloResultTableGraph.vue';
import { filter, map } from 'lodash';
import RenderIfInView from './RenderIfInView.vue';
import rockyKeywordScreenMixin, {
  KEYWORD_SCREENS,
  MAX_TABLE_ROWS,
  mapResearchResultRow,
  summarize,
  short as rockyShort,
} from './rockyKeywordScreen.js';

export default {
  mixins: [rockyKeywordScreenMixin],
  props: {
    researchHistory: {
      default: () => []
    },
    report: {
      default: null
    },
    title: {
      default: ""
    },
    reportType: {
      default: null
    },
    // filled if reportType === 'SiloResearchTopic'
    siloResearchType: {
      default: null
    },
    // filled if reportType === 'SiloResearchTopic'
    topicsWithMetrics: {
      default: () => []
    },
    // filled if reportType === 'SiloResearchTopic'
    parentReport: {
      default: null
    },
    showSiloExtraActions: {
      default: false
    },
    hasUnlimitedAccess: {

    },
    showModal: {
      default: false
    },
    modalTitle: {
      default: ''
    },
    modalType: {
      default: 0
    },
    reportTitle: {
      default: ''
    },
    suppressPopTaScoreHeader: {
      type: Boolean,
      default: false,
    },
    isContentOnlyView: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RadialProgressBar,
    KeywordResearchResultControls,
    HorizontalTwoScrollBar,
    SiloPopUp,
    SiloBulkPopUp,
    KeywordResearchModal,
    PopTaScoreLabel,
    ContentOrderForm,
    SiloResultTableGraph,
    RenderIfInView,
  },
  watch: {
    report: function (newVal) {
      if (newVal) {
        this.updateFilterRangeReset()
        this.loadKeywordTrack()
      }
      this.emitRockyKeywordScreen()
    },
    // View-state changes re-emit the Rocky snapshot (debounced so keystrokes
    // and slider drags coalesce).
    search () { this.emitRockyKeywordScreenDebounced() },
    sortField () { this.emitRockyKeywordScreenDebounced() },
    sortBy () { this.emitRockyKeywordScreenDebounced() },
    allAppliedFilters: {
      deep: true,
      handler () { this.emitRockyKeywordScreenDebounced() },
    },
    showAdvancedMetrics () { this.emitRockyKeywordScreenDebounced() },
    selectedKeywords () { this.emitRockyKeywordScreenDebounced() },
    currentAIAsyncTask: function (newVal, oldVal) {
      if (newVal && !oldVal) {
        this.isAwaitingAIAsyncTaskStatus = false;
      }
      if (newVal?.is_completed && newVal?.is_completed !== oldVal?.is_completed) {
        this.$store.commit('hideLoading');
        this.$emit('onAIResultReady')
        this.sortField = 'keywordType'
        this.sortBy = 'desc'
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    selectedSubAccountRelation () {
      return this.$store.state.selectedSubAccountRelation
    },
    isSpecialAdminUser () {
      return this.$store.getters.isSpecialAdminUser
    },
    isSpecialOwnerSelected () {
      return this.$store.getters.isSpecialOwnerSelected
    },
    site () {
      return this.$store.getters.siteById(parseInt(this.$route.params.siteId)) || {}
    },
    isWhiteGloveUser () {
      if (!this.user) return false;

      const accountType = this.$store.state.selectedSubAccountRelation
        ?this.$store.state.selectedSubAccountRelation.ownerAccountType
        :this.user.accountType

      if (whiteGlovePlans.includes(getPureServicePkgName(accountType))) {
        return true;
      }
      return false;
    },
    isMissionControlSession () {
      return this.$store.state.selectedSubAccountRelation?.isMissionControlSubAccount
    },
    filteredSilos() {
      const result = this.siloSearch ? this.silos.filter(silo => silo.name?.toLowerCase().includes(this.siloSearch?.toLowerCase())) : this.silos
      return result.toSorted((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      })
    },
    allSiloKeywords() {
      return this.silos.flatMap(silo => silo.silo_keywords.filter(k => !k.isDeleted).map(siloKeyword => siloKeyword.keyword))
    },
    allOrderedSiloKeywords() {
      return this.silos.filter(silo => silo?.content_report_order && silo?.content_report_order?.order_status !== 'user_editing').flatMap(silo => silo.silo_keywords.filter(k => !k.isDeleted).map(siloKeyword => siloKeyword.keyword))
    },
    allQuickContentOrderKeywords() {
      return this.quickContentSilos.filter(silo => silo?.content_report_order && silo?.content_report_order?.order_status !== 'user_editing').flatMap(silo => silo.silo_keywords.filter(k => !k.isDeleted).map(siloKeyword => siloKeyword.keyword))
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    campaignId () {
      const fromRoute = parseInt(this.$route.params.campaignId || 0, 10)
      if (fromRoute) return fromRoute
      return parseInt(this.report?.campaignId || 0, 10)
    },
    siteId () {
      return parseInt(this.$route.params.siteId || 0)
    },
    isURL () {
      return isURL
    },
    tableId () {
      if (this.report) {
        return 'research_table' + this.report.id
      } else {
        return 'empty_table'
      }
    },
    filteredRows () {
      if (!this.report) {
        return []
      }
      let rlt = this.report.result

      if (this.reportType === 'SiloResearchTopic' && this.siloResearchType === 'custom-silo') {
        rlt = rlt.filter(row => !!row.hasMetrics)
      }

      const search = this.search ? this.search.toLowerCase() : ''

      if (search) {
        rlt = rlt.filter(row => String(row.keyword).includes(search))
      }

      const {
        filterKeywordScoreRange,
        filterKGRRange,
        filterDifficultyScoreRange
      } = this.allAppliedFilters

      let sortField = this.sortField
      let sortBy = this.sortBy
      rlt = rlt.sort((a, b) => {
        if (sortField === 'keywordType') {
          const groupRank = (row) => {
            const t = this.keywordTypeSortTier(row)
            const map = { 5: 0, 4: 1, 3: 2, 2: 3, 1: 4 }
            return map[t] ?? 99
          }
          const orderedRank = (row) => (
            this.allOrderedSiloKeywords.includes(row.keyword) ||
            this.allQuickContentOrderKeywords.includes(row.keyword)
          ) ? 0 : 1

          let cmp = groupRank(a) - groupRank(b)
          if (cmp !== 0) return cmp

          cmp = orderedRank(a) - orderedRank(b)
          if (cmp !== 0) return cmp

          let aVal = a.keywordScore
          let bVal = b.keywordScore
          if (sortBy == 'asc') {
            if (aVal > bVal) return 1
            if (aVal < bVal) return -1
          } else {
            if (aVal > bVal) return -1
            if (aVal < bVal) return 1
          }
          return 0
        }

        let aVal = a[sortField];
        let bVal = b[sortField];

        // for any equal values, default to sorting by BMMS High
        if (aVal === bVal) {
          aVal = a['keywordScore'];
          bVal = b['keywordScore'];
        }

        if (sortBy == 'asc') {
          if (aVal > bVal) return 1;
          if (aVal < bVal) return -1;
        } else {
          if (aVal > bVal) return -1;
          if (aVal < bVal) return 1;
        }
        return 0;
      }).filter(r => {
        if (r['isHidden']) {
          return false;
        }

        if (filterKeywordScoreRange) {
          let [ minVal, maxVal ] = filterKeywordScoreRange
          if ( r['keywordScore'] < minVal || r['keywordScore'] > maxVal ) {
            return false;
          }
        }
        if (filterKGRRange) {
          let [ minVal, maxVal ] = filterKGRRange
          if (r['KGRScore'] < minVal || r['KGRScore'] > maxVal ) {
            return false;
          }
        }
        if (filterDifficultyScoreRange) {
          let [ minVal, maxVal ] = filterDifficultyScoreRange
          if (r['difficultyScore'] < minVal || r['difficultyScore'] > maxVal) {
            return false;
          }
        }

        return true;
      }).map(r => {
        const updateRates = this.getSearchVolumeUpdate(r.searchVolumeFor24Month || [])
        let monthlyUpdate = {}
        updateRates.map(u => {
          monthlyUpdate[SEARCH_COLUMN_VALUES[u.month - 1]] = u.updateRate ? (u.updateRate.toFixed(2)) : '-'
        })
        return {
          ...r,
          ...monthlyUpdate
        }
      })
      return rlt;
    },
    tableBodySections () {
      const rows = this.filteredRows
      if (this.sortField !== 'keywordType') {
        return [{ header: null, rows, startRowIndex: 0 }]
      }
      const sections = []
      let startRowIndex = 0
      let i = 0
      while (i < rows.length) {
        const tier = this.keywordTypeSortTier(rows[i])
        let j = i + 1
        while (j < rows.length && this.keywordTypeSortTier(rows[j]) === tier) {
          j += 1
        }
        const chunk = rows.slice(i, j)
        sections.push({
          header: {
            tier,
            label: this.keywordTypeGroupLabelForTier(tier),
            count: chunk.length
          },
          rows: chunk,
          startRowIndex
        })
        startRowIndex += chunk.length
        i = j
      }
      return sections
    },
    rowsWithAdvancedMetrics () {
      return this.report?.result?.filter(row => row.hasAdvancedMetrics) || []
    },
    hiddenRows () {
      return this.report?.result?.filter(row => row.isHidden) || []
    },
    hiddenColumnsKeys () {
      const globalValue = this?.user?.settings?.keywordResearchResultTableHiddenColumnsKeysPerSite?.[this.siteId]
      if (globalValue === null || globalValue === undefined) {
        return HIDDEN_COLUMNS_KEYS_DEFAULT
      }
      return globalValue
    },
    hideableColumns () {
      return [
        // all columns
        ...this.tableColumns.filter((column) => [
          // except
          'keyword',
          'keywordType',
          ...MONTHLY_SEARCH_COLUMNS.map(c => c.key),
          ...SEARCH_TREND_COLUMNS.map(c => c.key)
        ].indexOf(column.key) < 0),

        // plus these special groupped columns
        ...this.isAdmin?[{ key: "_trafficEstimatePerMonth", label: "Traffic Estimates per Month by Rank Position"}]:[],  // special key to hide the whole group of MONTHLY_SEARCH_COLUMNS 
        { key: "_searchTrend", label: "Search Volume Trends"}  // special key to hide the whole group of SEARCH_TREND_COLUMNS 
      ]
    },
    visibleTableColumns () {
      return this.tableColumns.filter(column => {
        return this.isColumnVisible(column.key)
      })
    },
    forceHideSearchTrendChartColumn () {
      return this.filteredRows?.length || 0 > 10
    },
    keywordResultBodyColspan () {
      const cols = this.visibleTableColumns.filter(
        c => (c?.key === 'Search_Volumn_Chart' && !this.forceHideSearchTrendChartColumn) || c?.key !== 'Search_Volumn_Chart'
      )
      return 1 + cols.length + 1
    },
    asyncTasks() {
      return this.$store.state.asyncTasks
    },
    currentAIAsyncTask() {
      return this.asyncTasks.filter(task => task.id === this.report?.aiTaskId)[0]
    },
    activeSiloForOrderForm() {
      if (this.showContentOrderFormForSiloId) {
        return this.quickContentSilos.find(silo => silo.id === this.showContentOrderFormForSiloId)
      }
      return null
    },
    selectedKeywordIdsForOrder() {
      if (!this.activeSiloForOrderForm?.content_report_order) {
        return []
      }
      return [
        ...this.activeSiloForOrderForm?.content_report_order?.selected_top_level_keyword_ids || [],
        ...this.activeSiloForOrderForm?.content_report_order?.selected_supporting_keyword_ids || []
      ]
    },
    selectedKeywordsForOrder () {
      if (!this.activeSiloForOrderForm?.content_report_order) {
        return []
      }
      return this.activeSiloForOrderForm.silo_keywords.filter(keyword => this.selectedKeywordIdsForOrder.indexOf(keyword.id) >= 0)
    },
    graphData() {
      const keywords = this.report.result

      const topLevel = filter(keywords, 'isTopLevelKeyword')
      const supporting = filter(keywords, 'isSupportingKeyword')

      const mid = Math.ceil(supporting?.length / 2);
      const leftKeywords = supporting?.slice(0, mid) || [];
      const rightKeywords = supporting?.slice(mid) || [];

      const mk = (list) => map(list, 'keyword')
      return { center: topLevel[0]?.keyword, left: mk(leftKeywords), right: mk(rightKeywords) }
    },
    graphDataRepr() {
      return JSON.stringify(this.graphData)
    },
    trackedKeywords() {
      return this?.keywordTrackData?.trackKeywords || []
    },
    trackKeywordLists() {
      return this?.keywordTrackData?.keywordLists?.map(l => l.name) || []
    },
    hasLabeledKeywords() {
      return this.report?.result?.some(row => row.isTopLevelKeyword || row.isSecondaryKeyword || row.isSupportingKeyword) || false
    }
  },
  data () {
    return {
      silos: [],
      quickContentSilos: [],
      siloSearch: '',
      sortField: 'keywordType',
      sortBy: 'desc', // asc/desc

      showFilterPopup: false,
      showSiloPopup: false,
      filterKeywordScoreMinMax: [0, 100],
      filterKGRMinMax: [0, 100],
      filterDifficultyScoreMinMax: [0, 100],
      filterKeywordScoreRange: [0, 100],
      filterKGRRange: [0, 100],
      filterDifficultyScoreRange: [0, 100],

      allAppliedFilters: {},

      search: '',
      showAdvancedMetrics: false,

      keywordsOngoingLabelUpdate: [],

      showGraphChart: false,

      COMMON_COLUMNS: COMMON_COLUMNS,
      MONTHLY_SEARCH_COLUMNS: MONTHLY_SEARCH_COLUMNS,
      SEARCH_TREND_COLUMNS: SEARCH_TREND_COLUMNS,
      tableColumns: [],
      popUpSilo: null,
      keywordTrackData: null,

      aiTopicFieldValue: '',
      isStartingAIAsyncTask: false,
      isAwaitingAIAsyncTaskStatus: false,

      isCurrentIdx: null,
      selectedKeywords: [],
      bulkPopUp: false,

      showHiddenRowsModal: false,

      showContentOrderFormForKeywords: null,

      isHighlightRowHandled: false,
      isHighlightRowActive: false,
      highlightTimeout: null,

      showAddToNewTrackListModalFor: null,
      newListFieldValue: '',

      searchTrendChartOptions: {
        chart: {
          type: 'line',
          width: 100,
          height: 35,
          sparkline: {
            enabled: true
          },
          animations: {
            enabled: false,
          }
        },
        xaxis: {
          categories: SEARCH_TREND_COLUMNS.filter(col => col.value !== 'Search_Volumn_Chart').map(col => col.label),
          title: {
            text: 'Month'
          }
        },
        yaxis: {
          numeric: true,
        },
        tooltip: {
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            let title = w.globals.tooltip.tooltipTitle.outerHTML;
            let items = "";
            w.globals.tooltip.ttItems.forEach(x => {
                // update search trend tooltip color based on value
                if ( series[seriesIndex][dataPointIndex] > 0) {
                  x.style.color = '#007bff'
                } else {
                  x.style.color = '#dc3545'
                }
                items = items + x.outerHTML
            })
            return title + items;
          },
          fixed: {
            enabled: false
          },
          x: {
            show: true
          },
          y: {
            formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
              return `${value} %`
            },
            title: {
              formatter: function (seriesName) {
                return ''
              }
            }
          },
          marker: {
            show: false
          }
        }
      },
    }
  },
  methods: {
    keywordTypeSortTier (row) {
      if (row.isTopLevelKeyword && !row.isSecondaryKeyword) return 5
      if (row.isTopLevelKeyword && row.isSecondaryKeyword) return 4
      if (row.isSecondaryKeyword) return 3
      if (row.isSupportingKeyword) return 2
      return 1
    },
    keywordTypeGroupLabelForTier (tier) {
      const labels = {
        5: 'Top-level keywords',
        4: 'Secondary top-level keywords',
        3: 'Secondary keywords',
        2: 'Supporting keywords',
        1: 'Unmarked keywords'
      }
      return labels[tier] || 'Keywords'
    },
    // Rocky snapshot of the rendered results table. This component is reused
    // by several surfaces; only the two dedicated results routes emit — the
    // parents of those routes emit the loading/generating states themselves.
    buildRockyScreenData() {
      let screen = null
      const recordIds = {}
      if (this.$route.name === 'one-click-silo-single') {
        screen = KEYWORD_SCREENS.STRATEGY_RESULTS
        recordIds.siloResearchId = this.$route.params.id
        recordIds.topicId = this.report?.id
      } else if (this.$route.name === 'keyword-insight-single') {
        screen = KEYWORD_SCREENS.KEYWORD_INSIGHT_RESULTS
        recordIds.keywordResearchId = this.$route.params.id
      } else {
        return null
      }
      if (!this.report) return null
      const result = this.report.result || []
      const appliedFilters = {}
      const narrowed = (range) => Array.isArray(range) && (range[0] !== 0 || range[1] !== 100)
      const { filterKeywordScoreRange, filterKGRRange, filterDifficultyScoreRange } = this.allAppliedFilters || {}
      if (narrowed(filterKeywordScoreRange)) appliedFilters.keywordScoreRange = filterKeywordScoreRange
      if (narrowed(filterKGRRange)) appliedFilters.kgrRange = filterKGRRange
      if (narrowed(filterDifficultyScoreRange)) appliedFilters.difficultyScoreRange = filterDifficultyScoreRange
      return {
        screen,
        status: result.length ? 'ready' : 'empty',
        loading: false,
        recordIds,
        data: {
          title: rockyShort(this.title),
          locationCode: this.report?.locationCode ?? this.parentReport?.locationCode ?? null,
          languageCode: this.report?.languageCode ?? this.parentReport?.languageCode ?? null,
          rows: summarize(this.filteredRows, mapResearchResultRow, MAX_TABLE_ROWS),
          buckets: {
            topLevelCount: result.filter(r => r.isTopLevelKeyword).length,
            secondaryTopLevelCount: result.filter(r => r.isSecondaryKeyword).length,
            supportingCount: result.filter(r => r.isSupportingKeyword).length,
            hiddenCount: this.hiddenRows.length,
            totalCount: result.length,
          },
          viewState: {
            search: rockyShort(this.search),
            sortField: this.sortField,
            sortBy: this.sortBy,
            appliedFilters,
            showAdvancedMetrics: !!this.showAdvancedMetrics,
            selectedKeywordCount: this.selectedKeywords.length,
          },
        },
      }
    },
    getRowSearchTrendSeries(row) {
      return [{
          name: "Search Trend",
          data: SEARCH_TREND_COLUMNS
            .filter(col => col.value !== 'Search_Volumn_Chart')
            .map(col => row[col.value])
            .map(value => {
              if ([null, undefined, '-'].includes(value)) return 0; 
              return Number(value);
            })
      }]
    },
    cancelModal() {
      this.$emit('cancel');
    },
    closeModal() {
      this.$emit('close');
    },
    openHowtoUseGuide() {
      window.open('https://help.pageoptimizer.pro/article/difference-between-top-level-and-supporting-content-keywords', '_blank')
    },
    updateReportTitle(value) {
      this.$emit('update-title', value);
    },
    gotoPage(url) {
      this.$router.push(url)
    },
    pageScoreTintColor(score) {
      return pageScoreTintColor(score)
    },
    gotoNewPopReport(keywordReport) {
      const { siteId } = this.$route.params;
      const externalData = {
        keyword: keywordReport.keyword,
        lang: this.report.languageCode,
        loc: this.report.locationCode,
        isPageNotBuilt: !keywordReport.currentRankingUrl,
        url: keywordReport.currentRankingUrl,
        type: this.reportType,
        id: this.report.id,
      };

      this.$router.push({
        name: 'NewPage',
        params: {
          siteId,
          externalData,
        }
      });
    },
    keywordTypeColumnTooltip(col) {
      if (col.key !== 'keywordType') {
        return col.tooltipText;
      }
      if (this.isWhiteGloveUser) {
        return 'Indicates whether a keyword is a <b>primary focus (Top Level)</b> for a content plan or a <b>related term (Supporting Keyword)</b> that helps reinforce the topic.';
      }
      return col.tooltipText;
    },
    fetchSiloFromKeyword(keyword) {
      return this.silos.find(silo => silo.silo_keywords.some(siloKeyword => siloKeyword.keyword === keyword))
    },
    fetchContentOrderSiloFromKeyword(keyword) {
      return this.quickContentSilos.find(silo => silo.silo_keywords.some(siloKeyword => siloKeyword.keyword === keyword))
    },
    addKeywordToSilo(row, silo, closeModal) {
      if (!row.isTopLevelKeyword && !row.isSupportingKeyword) return;

      const topLevelKeywordsCount = silo.silo_keywords.filter(keyword => !keyword.isDeleted).filter(keyword => keyword.keywordData.isTopLevelKeyword)?.length || 0;
      const supportingKeywordsCount = silo.silo_keywords.filter(keyword => !keyword.isDeleted).filter(keyword => keyword.keywordData.isSupportingKeyword)?.length || 0;

      if (row.isTopLevelKeyword && topLevelKeywordsCount >= 4){
        this.$notify({
          group: 'info', type: 'warning',
          text: this.isWhiteGloveUser
            ? 'A content plan cannot have more than 4 Top-level keywords.'
            : 'Silo cannot have more than 4 Top-level keywords.'
        })
        if (closeModal) this.closeSiloModal(true);
        return;
      }
      
      if ((topLevelKeywordsCount + supportingKeywordsCount) >= 100){
        if (closeModal) this.closeSiloModal(true);
        return;
      }

      this.$store.commit('showLoading');

      this.$store
        .dispatch('addKeywordToSilo', {
          siloId: silo.id,
          body: {
            keyword: row.keyword,
            keywordData: {
              ...row,
              locationCode: this.report.locationCode,
              languageCode: this.report.languageCode,
            },
            sourceReportType: this.reportType,
            sourceReportId: this.report.id,
          },
        })
        .then((response) => {
          const siloName = response.data.siloName
          this.$store.commit('setIsNewSiloUpdates', true);
          this.$notify({
            group: 'info', type: 'success',
            text: this.isWhiteGloveUser
              ? `Successfully added keywords to the ${siloName} content plan.`
              : `Successfully added keywords to ${siloName} silo.`
          })
          this.fetchSilos();
        })
        .catch(() => this.$notify({
          group: 'info', type: 'danger',
          text: this.isWhiteGloveUser
            ? 'Failed to add keyword to content plan.'
            : 'Failed to add keyword to silo.'
        }))
        .finally(() => this.$store.commit('hideLoading'));
    },
    bulkAddKeywordToSilo(siloId, closeModal) {

      const silo = this.silos.find(silo => silo.id == siloId)
      const topLevelKeywordsCount = silo?.silo_keywords.filter(keyword => !keyword.isDeleted).filter(keyword => keyword.keywordData.isTopLevelKeyword)?.length || 0;
      const supportingKeywordsCount = silo?.silo_keywords.filter(keyword => !keyword.isDeleted).filter(keyword => keyword.keywordData.isSupportingKeyword)?.length || 0;

      const selectedTopLevelKeywordsCount = this.selectedKeywords.filter(keyword => keyword.isTopLevelKeyword)?.length || 0;
      const selectedSupportingKeywordsCount = this.selectedKeywords.filter(keyword => keyword.isSupportingKeyword)?.length || 0;

      if ((selectedTopLevelKeywordsCount + topLevelKeywordsCount) > 4){
        this.$notify({
          group: 'info', type: 'warning',
          text: this.isWhiteGloveUser
            ? 'A content plan cannot have more than 4 Top-level keywords.'
            : 'Silo cannot have more than 4 Top-level keywords.'
        })
        if (closeModal) this.closeBulkModal();
        return;
      }

      if ((topLevelKeywordsCount + supportingKeywordsCount + selectedTopLevelKeywordsCount + selectedSupportingKeywordsCount) > 100){
        this.$notify({
          group: 'info', type: 'warning',
          text: this.isWhiteGloveUser
            ? 'A content plan cannot have more than 100 keywords.'
            : 'Silo cannot have more than 100 keywords.'
        })
        if (closeModal) this.closeSiloModal(true);
        return;
      }

      this.$store.commit('showLoading');

      return this.$store
        .dispatch('addKeywordsToSilo', {
          siloId: siloId,
          body: {
            keywords: this.selectedKeywords,
            locationCode: this.report.locationCode,
            languageCode: this.report.languageCode,
            sourceReportType: this.reportType,
            sourceReportId: this.report.id,
          },
        })
        .then((response) => {
          const siloName = response.data.siloName
          this.$store.commit('setIsNewSiloUpdates', true);
          this.$notify({
            group: 'info', type: 'success',
            text: this.isWhiteGloveUser
              ? `Keywords added to the ${siloName} content plan.`
              : `Keywords added to ${siloName} silo.`
          })
          return this.fetchSilos();
        })
        .catch(() => this.$notify({
          group: 'info', type: 'danger',
          text: this.isWhiteGloveUser
            ? 'Failed to add keywords to content plan.'
            : 'Failed to add keywords to silo.'
        }))
        .finally(
          () => {
            this.$store.commit('hideLoading');
            this.closeBulkModal();
            if (!keywords) {
              this.selectedKeywords = [];
            }
          }
        );
    },
    closeSiloModal(refreshData = false) {
      this.popUpSilo = null;
      if (refreshData) this.fetchSilos();
    },
    openSiloModal(row) {
      this.popUpSilo = row;
    },
    closeBulkModal() {
      this.bulkPopUp = false;
    },
    openBulkModal() {
      // Check if Selected Keywords is empty
      if (this.selectedKeywords.length === 0) {
        this.$notify({
          group: 'info', type: 'warning',
          text: this.isWhiteGloveUser
            ? 'Please select keywords to add to a content plan.'
            : 'Please select keywords to add to silo.'
        })
        return;
      }
      // Check if selected keywords are marked as top level or supporting
      const unmarkedKeywordsCount = this.selectedKeywords.filter(keyword => 
        !keyword.isTopLevelKeyword && !keyword.isSupportingKeyword
      ).length;
      if (unmarkedKeywordsCount) {
        this.$notify({
          group: 'info', type: 'warning',
          text: 'Some of the selected keywords are not marked as Top Level or Supporting Level.'
        })
        return;
      }
      // Check if selected keywords are marked as top level or supporting
      const topLevelKeywordsCount = this.selectedKeywords.filter(keyword => 
        !!keyword.isTopLevelKeyword
      ).length;
      if (topLevelKeywordsCount > 4) {
        this.$notify({
          group: 'info', type: 'warning',
          text: 'Cannot add more than 4 top-level keywords.'
        })
        return;
      }
      // Check if selected keywords are already in a silo / content plan
      // (keywords removed from a silo no longer count, like the row badge)
      const selectedKeywordsSet = new Set(this.selectedKeywords.map(keyword => keyword.keyword));
      if (this.allSiloKeywords.some(keyword => selectedKeywordsSet.has(keyword))) {
        this.$notify({
          group: 'info', type: 'warning',
          text: this.isWhiteGloveUser
            ? 'Some selected keywords are already in a content plan.'
            : 'Some selected keywords are already in silo.'
        })
        return;
      }
      this.bulkPopUp = true;
    },
    applyKeywordSilo(siloId) {
      if (!siloId) return

      this.$router.push(`/sites/${this.siteId}/campaign/${this.campaignId}/silo?id=${siloId}`)
    },
    applyKeywordContentOrderSilo(siloId) {
      if (!siloId) return

      const { siteId } = this.$route.params
      this.$router.push(`/sites/${siteId}/quick-content-orders?id=${siloId}`)
    },
    applyFitlersAction() {
      this.allAppliedFilters = {
        filterKeywordScoreRange: this.filterKeywordScoreRange,
        filterKGRRange: this.filterKGRRange,
        filterDifficultyScoreRange: this.filterDifficultyScoreRange,
      }
    },
    toLocalDateTimeString (d) {
      return toLocalDateTimeString(d)
    },
    changeSortField (field) {
      if (field === this.sortField) {
        if (this.sortBy === "desc") {
          this.sortBy = 'asc';
        } else {
          this.sortBy = 'desc';
        }
      } else {
        this.sortField = field;
      }
    },
    renderCellValue (key, value) {
      let prefix = '';
      let suffix = '';

      switch (key) {
        case 'difficultyScore':
          suffix = '%';
          break;
        case 'cost':
          prefix = '$';
          break;
        default:
          break;
      }
      if (SEARCH_TREND_COLUMNS.map(i => i.value).includes(key) && value != '-') {
        suffix = '%';
      }
      const printValue = value === undefined ? '': value
      return (prefix + printValue + suffix)
    },
    styleForCell (key, rowData) {
      let color = ''
      const value = rowData[key]
      switch (key) {
        case 'keyword':
          if (rowData['monthlySearch'] <= 10) { // if we didn't find monthly search default value is 10;
            // color = '#EB5757'
          }
          break;
        case 'keywordScore':
          if (value > 90) {
            color = '#12814C'
          } else if (value > 58) {
            color = '#12814C'
          }
          break;
        // case 'KGRScore':
        //   if (value <= 2.5) {
        //     color = '#00CD49'
        //   } else if (value > 2.5 && value <= 5) {
        //     color = '#FF9B2D'
        //   } else {
        //     color = '#FF1F2D'
        //   }
        //   break;
        default:
          break;
      }

      if (SEARCH_TREND_COLUMNS.filter(col => col.value !== 'Search_Volumn_Chart').map(i => i.value).includes(key)) {
        if (value > 0) {
          color = '#007bff'
        } else {
          color = '#dc3545'
        }
      }
      let style = {}
      if (color) {
        style['color'] = color;
      }
      return style;
    },
    keywordScoreToColorStyles (keywordScore) {
      if (keywordScore > 90)
        return { 'background-color': '#006B3E', 'color': '#FFFFFF' }
      else if (keywordScore > 80 && keywordScore <= 90)
        return { 'background-color': '#009254', 'color': '#FFFFFF' }
      else if (keywordScore > 70 && keywordScore <= 80)
        return { 'background-color': '#49BA8B', 'color': '#FFFFFF' }
      else if (keywordScore > 65 && keywordScore <= 70)
        return { 'background-color': '#65DDAB', 'color': '#014751' }
      else if (keywordScore > 60 && keywordScore <= 65)
        return { 'background-color': '#A6EFD1', 'color': '#014751' }
      else if (keywordScore > 50 && keywordScore <= 60)
        return { 'background-color': '#DAFFF0', 'color': '#014751' }
      else
        return { 'color': '#014751' }
    },
    getMonthUpdate (month, search_volumes) {
      try {
        if (search_volumes.length < 1) {
            return null
        }
        let month_search_volumes = search_volumes.filter(s => s.month == month)

        if (month_search_volumes.length < 1) {
            return null
        }
        let avg_search_volume = month_search_volumes.map(s => s.search_volume).reduce((a, b) => a + b) / month_search_volumes.length
        let recent_year = month_search_volumes.map(m => m.year).sort().reverse()[0]
        let recent_year_search_volume = month_search_volumes.filter(m => m.year == recent_year)[0].search_volume
        if (recent_year_search_volume < 1) {
            return null
        }
        const result = (avg_search_volume / recent_year_search_volume - 1) * 100
        return result
      } catch (e) {
        return 12345678
      }
    },
    getSearchVolumeUpdate (searchVolumes) {
      const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
      let results = []
      for (let index = 0; index < months.length; index++) {
          const m = months[index];
          const updateRate = this.getMonthUpdate(m, searchVolumes)
          results.push({
              month: m,
              updateRate: updateRate
          })
      }
      return results
    },
    changeResearchAction (id) {
      this.$emit('onChangeResearchId', id)
    },
    renameResearchAction (name, id) {
      this.$emit('rename', name, id)
    },
    updateFavoriteStatus (item) {
      this.$emit('toggle-favorite', item)
    },
    deleteResearchAction (id) {
      this.$emit('delete', id)
    },
    updateFilterRangeReset () {
      if (this.report) {
        let result = this.report.result;
        const keywordScoreList = result.map(r => r['keywordScore']).filter(r => r != undefined)
        const KGRScoreList = result.map(r => r['KGRScore']).filter(r => r != undefined)
        const difficultyScoreList = result.map(r => r['difficultyScore']).filter(r => r != undefined)
        
        const keywordScoreMin = Math.floor(Math.min(...keywordScoreList))
        const keywordScoreMax = Math.ceil(Math.max(...keywordScoreList))
        const KGRScoreMin = Math.floor(Math.min(...KGRScoreList))
        const KGRScoreMax = Math.ceil(Math.max(...KGRScoreList))
        const difficultyScoreMin = Math.floor(Math.min(...difficultyScoreList))
        const difficultyScoreMax = Math.ceil(Math.max(...difficultyScoreList))
        
        this.filterKeywordScoreMinMax = [ keywordScoreMin, keywordScoreMax ]
        this.filterKGRMinMax = [ KGRScoreMin, KGRScoreMax ]
        this.filterDifficultyScoreMinMax = [difficultyScoreMin, difficultyScoreMax]

        this.filterKeywordScoreRange = [ keywordScoreMin, keywordScoreMax ]
        this.filterKGRRange = [ KGRScoreMin, KGRScoreMax ]
        this.filterDifficultyScoreRange = [difficultyScoreMin, difficultyScoreMax]

        this.allAppliedFilters = {}
      }

    },
    toggleSelectedKeyword (r) {
      if (this.selectedKeywords.includes(r)) {
        this.selectedKeywords = this.selectedKeywords.filter(k => k !== r)
      } else {
        this.selectedKeywords = [...this.selectedKeywords, r]
      }
    },
    toggleSelectAll () {
      if (this.selectedKeywords.length === this.filteredRows.length) {
        this.selectedKeywords = []
      } else {
        this.selectedKeywords = [...this.filteredRows]
      }
    },
    resetSelectedKeywords() {
      this.selectedKeywords = []
    },
    toggleTrackUntrackKeyword (shouldAddToTrack, item, listName=null) {
      let data = {}
      if (shouldAddToTrack) {
        data = {
          campaignId: this.campaignId,
          trackKeyword: item.keyword,
          trackData: item,
          listName,
          languageCode: this.report.languageCode,
          locationCode: this.report.locationCode,
          domain: this.report.domain
        }
        this.$store.commit('showLoading');
        this.$store.dispatch('addKeywordToTrack', data)
        .then(response => {
          if (response.data && response.data.status == 'SUCCESS') {
            this.$store.commit('setIsNewTrackingUpdates', true);
            this.keywordTrackData = response.data.keywordTrack
            this.$notify({
              group: 'info', type: 'success',
              text: 'Successfully added keyword to track.'
            })
            if (this.showAddToNewTrackListModalFor) {
              this.showAddToNewTrackListModalFor = null;
            }
          } else {
            this.$notify({
              group: 'info', type: 'error',
              text: response.data.msg || 'Failed to add keyword to the track.'
            })
          }
        })
        .finally(() => {
          this.$store.commit('hideLoading')
        })
      } else {
        data = {
          campaignId: this.campaignId,
          trackKeyword: item.keyword,
        }

        this.$store.commit('showLoading');
        this.$store.dispatch('removeKeywordFromTrack', data)
        .then(response => {
          if (response.data && response.data.status == 'SUCCESS') {
            this.keywordTrackData = response.data.keywordTrack
            this.$notify({
              group: 'info', type: 'success',
              text: 'Successfully removed keyword from track.'
            })
          } else {
            this.$notify({
              group: 'info', type: 'error',
              text: 'Failed to remove keyword from the track.'
            })
          }
        })
        .finally(() => {
          this.$store.commit('hideLoading')
        })
      }
    },
    bulkTrackKeyword () {
      let data = {
        campaignId: this.campaignId,
        trackKeywords: this.selectedKeywords,
        languageCode: this.report.languageCode,
        locationCode: this.report.locationCode,
        domain: this.report.domain
      }
      this.$store.commit('showLoading');
      this.$store.dispatch('bulkTrackKeywordToTrack', data)
      .then(response => {
        if (response.data && response.data.status == 'SUCCESS') {
          response.data.added && this.$store.commit('setIsNewTrackingUpdates', true);
          this.loadKeywordTrack()
          this.$notify({
            group: 'info', type: 'success',
            text: response.data.added ? 'POP is now tracking these keywords.' : 'Keywords are removed from tracking.'
          })
        } else {
          this.$notify({
            group: 'info', type: 'error',
            text: 'Failed to update keywords.'
          })
        }
      })
      .finally(() => {
        this.$store.commit('hideLoading')
        this.selectedKeywords = []
      })
    },
    updateKeywordsVisibility(keywords, visible) {
      let data = {
        researchClass: this.reportType,
        researchId: this.report.id,
        keywords,
        visible
      }
      this.$store.commit('showLoading');
      this.$store.dispatch(
        'updateKeywordsVisibility',
        data
      )
      .then(response => {
        if (response.data && response.data.status == 'SUCCESS') {
          this.selectedKeywords = this.selectedKeywords.filter(k => !keywords.includes(k.keyword))
          this.$emit('refreshReport')
          this.$notify({
            group: 'info', type: 'success',
            text: `Successfully ${visible ? 'unhidden' : 'hidden'} keyword${keywords.length > 1 ? 's' : ''}.`
          })
        }  else {
          this.$notify({
            group: 'info', type: 'error',
            text: `Failed to ${visible ? 'unhide' : 'hide'} keyword${keywords.length > 1 ? 's' : ''}.`
          })
        }
      })
      .finally(() => {
        this.$store.commit('hideLoading')
      })
    },
    fetchSilos() {
      // only keyword names/labels + order selections are read from these lists
      return this.$store.dispatch('getSilos', {
        campaignId: this.campaignId,
        paginate: 0,
        includeKeywords: 1,
        includeAiAndPageRunResult: 0,
        includeGuardDiffData: 0,
        includePage: 0,
      }).then(response => {
        this.silos = response.data.data;
        return this.$store.dispatch('getSilos', {
          campaignId: this.campaignId,
          paginate: 0,
          isForQuickContentOrder: 1,
          includeKeywords: 1,
          includeAiAndPageRunResult: 0,
          includeGuardDiffData: 0,
          includePage: 0,
        }).then(response => {
          this.quickContentSilos = response.data.data;
          return
        })
      })
    },
    handleHighlightRow() {
      this.isHighlightRowHandled = true
      const found = document.querySelector('.highlight-row');
      if (found) {
        found.scrollIntoView({behavior: 'smooth'});
        this.isHighlightRowActive = true
        this.highlightTimeout = setTimeout(() => {
          this.isHighlightRowActive = false
        }, 3000);
      }
    },
    loadKeywordTrack () {
      this.$store.dispatch('getKeywordTrackForCampaign', this.campaignId)
      .then(response => {
        if (response.data && response.data.status == 'SUCCESS') {
          this.keywordTrackData = response.data.keywordTrack
        }
      })
    },
    analyzeWithAI() {
      const formdata = {
        reportId: this.report.id,
        reportType: this.reportType,
        topic: this.aiTopicFieldValue
      }
      this.isStartingAIAsyncTask = true
      this.$store.dispatch('keywordResearchAnalyzeWithAI', formdata)
      .then(response => {
        if (response?.data?.status === 'SUCCESS') {
          this.$emit('refreshReport');
          this.$store.commit('triggerAsyncTasksRefresh');
          this.isAwaitingAIAsyncTaskStatus = true;
          this.isStartingAIAsyncTask = false
        } else {
          return Promise.reject()
        }
      })
      .catch(() => {
        this.isStartingAIAsyncTask = false
      })
    },
    updateKeywordLabel(keywords, label, resetExistingTopLevelKeywords = false) {
      const formdata = {
        reportId: this.report.id,
        reportType: this.reportType,
        keywords,
        label,
        resetExistingTopLevelKeywords,
      }
      this.keywordsOngoingLabelUpdate = [...this.keywordsOngoingLabelUpdate, ...keywords]
      this.$store.dispatch('updateKeywordLabel', formdata)
      .then(response => {
        if (response?.data?.status === 'SUCCESS') {
          this.$emit('onKeywordLabelUpdateSuccess', keywords, label, resetExistingTopLevelKeywords)
          return Promise.resolve()
        } else {
          return Promise.reject()
        }
      })
      .finally(() => {
        this.keywordsOngoingLabelUpdate = this.keywordsOngoingLabelUpdate.filter(k => !keywords.includes(k))
        this.selectedKeywords = [];
      })
    },
    setColumnVisibility(targetKey, visible) {
      const updatedValue = this.hiddenColumnsKeys.filter(key => (
        key !== targetKey
      ))
      if (!visible) {
        updatedValue.push(targetKey)
      }

      const updatedUserSettings = {
        ...this.user.settings,
        keywordResearchResultTableHiddenColumnsKeysPerSite: {
          ...this.user.settings.keywordResearchResultTableHiddenColumnsKeysPerSite || {},
          [this.siteId]: updatedValue
        }
      }

      // eager update of settings state
      this.$store.commit('setUserSettings', updatedUserSettings)

      // persist in backend
      this.$store.dispatch('updateUserSettings', updatedUserSettings)
    },
    resetColumnVisibility() {
      const updatedUserSettings = {
        ...this.user.settings,
        keywordResearchResultTableHiddenColumnsKeysPerSite: {
          ...this.user.settings.keywordResearchResultTableHiddenColumnsKeysPerSite || {},
          [this.siteId]: HIDDEN_COLUMNS_KEYS_DEFAULT
        }
      }

      // eager update of settings state
      this.$store.commit('setUserSettings', updatedUserSettings)

      // persist in backend
      this.$store.dispatch('updateUserSettings', updatedUserSettings)
    },
    keywordResearchColumnMeta(targetKey) {
      return this.tableColumns.find(c => c.key === targetKey)
        || this.COMMON_COLUMNS.find(c => c.key === targetKey)
    },
    isColumnVisible(targetKey) {
      if (MONTHLY_SEARCH_COLUMNS.map(c => c.key).indexOf(targetKey) >= 0) {
        return this.hiddenColumnsKeys.indexOf('_trafficEstimatePerMonth') < 0
      }
      if (SEARCH_TREND_COLUMNS.map(c => c.key).indexOf(targetKey) >= 0) {
        return this.hiddenColumnsKeys.indexOf('_searchTrend') < 0
      }
      const meta = this.keywordResearchColumnMeta(targetKey)
      if (meta?.isAdvancedMetric && !this.showAdvancedMetrics) {
        return false
      }
      return this.hiddenColumnsKeys.indexOf(targetKey) < 0
    },
    isValidKeywordSelectionForContentOrder(keywords) {
      const inOrderedSiloKeywords = keywords.filter(keyword => this.allOrderedSiloKeywords.includes(keyword.keyword))
      const inContentOrderKeywords = keywords.filter(keyword => this.allQuickContentOrderKeywords.includes(keyword.keyword))

      if (inOrderedSiloKeywords.length) {
        return false
      }

      if (inContentOrderKeywords.length) {
        return false
      }

      const topLevelKeywordsCount = keywords.filter(keyword => keyword.isTopLevelKeyword).length
      const supportingKeywordsCount = keywords.filter(keyword => keyword.isSupportingKeyword).length
      return topLevelKeywordsCount + supportingKeywordsCount > 0
    },
  },
  mounted () {
    this.fetchSilos()
    if (this.report) {
      this.updateFilterRangeReset()
      this.loadKeywordTrack()
    }
    if (!this.isAdmin) {
      this.COMMON_COLUMNS = COMMON_COLUMNS.filter(item => !item.showOnlyAdmin)
    }
    if (this.reportType === 'KeywordResearch') {
      this.COMMON_COLUMNS = COMMON_COLUMNS.filter(item => item.key !== 'source')
    }

    this.tableColumns = [...this.COMMON_COLUMNS, ...this.isAdmin?MONTHLY_SEARCH_COLUMNS:[], ...SEARCH_TREND_COLUMNS]

    if (this.reportType === 'SupportKeywordResearch') {
      this.sortField = 'KGRScore'
      this.sortBy = 'asc'
    }

    if (this.$route.query.highlight && !this.isHighlightRowHandled) {
      this.$nextTick(() => {
        this.handleHighlightRow()
      })
    }

    this.emitRockyKeywordScreen()
  },
  beforeDestroy() {
    if (this.highlightTimeout) {
      clearTimeout(this.highlightTimeout)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./keyword-research.scss";

::v-deep {
  .wg-result-select-all-checkbox {
    label {
      color: var(--v-mainColor-base);
      font-size: 0.9rem;
    }

    .v-input--selection-controls__input {
      border: 1px solid #999999 !important;
      border-radius: 4px;
      height: 20px !important;
      width: 20px !important;
    }

    &.v-input--is-label-active {
      .v-icon {
        font-size: 16px !important;
      }
    }
  }
}
</style>

<style lang="scss">

#silo-name{
  color: var(--v-profileAnchorColor-base)
}

.hidden-rows-modal {
  .message-text, .message-text * {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

.filter-bullet {
  position: absolute;
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  top: 3px;
  right: 22px;
  background: var(--v-redColor-base);
}

.custom-v-card{
  margin-top: -80px !important;
}

/* Per-row keyword actions: ghost / flat controls (scoped to this table column only) */
.kr-result-row-actions {
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 2px;
}

.kr-result-row-actions .v-btn {
  min-width: 40px !important;
  padding: 0 6px !important;
}

.kr-result-row-actions .box-wh35 i.material-icons-outlined:not(.green-check),
.kr-result-row-actions .box-wh35 i.material-icons:not(.green-check) {
  border: none !important;
  background: transparent !important;
  padding: 0 !important;
  font-size: 22px;
}

.kr-result-row-actions .box-wh35 i.material-icons-outlined:not(.disabled-field):not(.green-check) {
  color: var(--v-profileAnchorColor-base) !important;
}

.kr-result-row-actions .box-wh35 i.success,
.kr-result-row-actions .box-wh35 i.material-icons.success {
  border: none !important;
  background: transparent !important;
  padding: 0 !important;
}

.kr-result-row-actions .box-wh35 i.disabled-field:not(.success) {
  border: none !important;
  background: transparent !important;
}

.kr-result-row-actions .box-wh35 .quick-content-icon {
  border: none !important;
  background: transparent !important;
  padding: 0 !important;
}

.kr-result-row-actions .box-wh35 i:hover:not(.disabled-field):not(.success):not(.green-check) {
  border: none !important;
  background-color: transparent !important;
  opacity: 0.85;
}

.kr-result-row-actions .box-wh35 i.disabled-field:hover {
  border: none !important;
  background-color: transparent !important;
}

.kr-result-row-actions .box-wh35 .quick-content-icon:hover:not(.disabled-field) {
  border: none !important;
  background-color: transparent !important;
  opacity: 0.85;
}

.kr-result-row-actions .box-wh35 .quick-content-icon.disabled-field:hover {
  border: none !important;
}

</style>
